import React from "react";


export const Textarea = ({
  placeholder,
  value,
  onChange,
}) => {
  return (
    <textarea
      className="w-full h-full outline-none  text-white bg-transparent placeholder:text-white resize-none scrollbar-hide text-[16px]  "
      placeholder={placeholder}
      value={value}
      onChange={onChange}
    />
  );
};
